module.exports = __webpack_public_path__ + "static/media/2.cde1c873.jpg";